'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reducer;
// Hint: Ducks pattern

// ------------------------------------
// 1. Constants
// ------------------------------------
var SET_CSRFTOKEN = exports.SET_CSRFTOKEN = '@@redux-csrf/setCsrfToken';

// ------------------------------------
// 2. Actions Creators
// ------------------------------------
var actions = exports.actions = {
  setCsrfToken: function setCsrfToken(csrfToken) {
    return {
      type: SET_CSRFTOKEN,
      payload: csrfToken
    };
  }
};

// ------------------------------------
// 3. Reducer as default
// ------------------------------------
var initialState = '';

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SET_CSRFTOKEN:
      return action.payload;
    default:
      return state;
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-csrf/lib/index.js
// module id = 782
// module chunks = 0